import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { paths } from '@/shared/lib/paths';
import { StatusPage } from './status-page';

/** Página 404. */
export function NotFoundPage(): ReactNode {
  return (
    <StatusPage title="Página não encontrada" description="O endereço acessado não existe.">
      <Link className="underline" to={paths.home()}>
        Voltar ao início
      </Link>
    </StatusPage>
  );
}
